import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectBillingRules,
  selectBuyerSettings,
  selectDecipherHashKeyIds,
  selectIsBillingRulesLoading,
  selectIsLoading,
  selectIsSaving,
} from './buyer.selectors';

@Injectable({ providedIn: 'root' })
export class BuyerSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly buyerSettings = this._store.selectSignal(selectBuyerSettings);
  public readonly billingRules = this._store.selectSignal(selectBillingRules);
  public readonly isBillingRulesLoading = this._store.selectSignal(
    selectIsBillingRulesLoading,
  );
  public readonly decipherHashKeyIds = this._store.selectSignal(
    selectDecipherHashKeyIds,
  );
  public readonly isLoading = this._store.selectSignal(selectIsLoading);
  public readonly isSaving = this._store.selectSignal(selectIsSaving);
}
